import { render, staticRenderFns } from "./recommend_tab.vue?vue&type=template&id=0426e99d&scoped=true&"
import script from "./recommend_tab.vue?vue&type=script&lang=ts&"
export * from "./recommend_tab.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_tab.vue?vue&type=style&index=0&id=0426e99d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0426e99d",
  null
  
)

export default component.exports